var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#c3f392",
    height: 40,
    width: 15,
    y: 30,
    x: 17.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "18;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.2s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "64;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#a66b95",
    height: 40,
    width: 15,
    y: 30,
    x: 42.5
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.1s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#eff3eb",
    height: 40,
    width: 15,
    y: 30,
    x: 67.5
  }, /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "20.999999999999996;30;30",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "y"
  }), /*#__PURE__*/React.createElement("animate", {
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    values: "58.00000000000001;40;40",
    keyTimes: "0;0.5;1",
    calcMode: "spline",
    dur: "1s",
    repeatCount: "indefinite",
    attributeName: "height"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.7616f5ada8c4f3b9dcedc3431a217091.svg";
export { ForwardRef as ReactComponent };